import React, { useState } from "react"
import { Button, Spinner, Table } from "reactstrap"
import ViewDriveData from "./ViewDriveData"

function MissingData({ Data, title, loading }) {
  const [rowData, setRowData] = useState([])
  const [UFRID, setUFRID] = useState()

  const [viewDriveData, setViewDriveData] = useState(false)
  const toggleViewDriveData = () => {
    setViewDriveData(!viewDriveData)
  }

  return (
    <div>
      {loading ? (
        <div
          style={{ height: "300px" }}
          className="d-flex justify-content-center align-items-center"
        >
          <Spinner type="border" size="lg" color="secondary" />
        </div>
      ) : (
        <>
          <Table className="project-list-table table-nowrap text-center align-middle table-borderless">
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Files</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {Data.map((item, key) => (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{item.AnswerAt}</td>
                  <td>{item.num}</td>
                  <td>
                    <Button
                      onClick={() => {
                        setRowData(item[title])
                        setUFRID(item.id)
                        toggleViewDriveData()
                      }}
                    >
                      View
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <ViewDriveData
            rowData={rowData}
            UFRID={UFRID}
            viewDriveData={viewDriveData}
            toggleViewDriveData={toggleViewDriveData}
          />
        </>
      )}
    </div>
  )
}

export default MissingData
